module.exports = __webpack_public_path__ + "static/media/takeda.b02c2c05.png";